// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c5704e1","455":"069ce3b6","946":"08e750fa"}[chunkId] + ".chunk.js";
};